import React from 'react';
import PropTypes from 'prop-types';
import AppTable from 'components/AppTable';
import withTableProps from 'HOC/types/withTable';
import { transformTableData } from 'utils';
import { getSessionsScheduledConfig } from './helpers/getSessionTablesConfig';
import { formatTrainingModuleLabel, formatTrainingPartLabel } from './helpers/formatTrainingLabels';

const SessionsScheduledTable = ({ tableData, helpers }) => {
  const rows = (Array.isArray(tableData.data) ? tableData.data : []).map(item => ({
    ...item,
    trainingModuleLabel: formatTrainingModuleLabel(item.trainingModuleCode, item.trainingModuleName),
    trainingPartLabel: formatTrainingPartLabel(item.trainingPartVersionCode, item.trainingMethod),
    expirationDate: item.expirationDate ?? item.evidenceExpiresAt ?? null,
  }));

  const tableConfig = getSessionsScheduledConfig();
  const [columns, tableRows] = transformTableData(tableConfig, rows);

  const tableActions = [
    {
      type: 'icon',
      icon: 'edit',
      onClick: helpers.editSession,
    },
    {
      type: 'icon',
      icon: 'delete',
      color: 'error',
      onClick: event => {
        helpers.removeParticipant(event);
        tableData.handleForceUpdate();
      },
    },
  ];

  return (
    <AppTable
      columns={columns}
      data={tableRows}
      totalCount={tableData.totalCount}
      rowsPerPage={tableData.pageSize}
      isLazyLoading
      onChangePage={tableData.handleChangePage}
      onColumnSorting={tableData.handleSorting}
      actions={tableActions}
      extraActionsKeys={['stationId']}
    />
  );
};

SessionsScheduledTable.propTypes = {
  tableData: PropTypes.shape(withTableProps).isRequired,
  helpers: PropTypes.shape({
    editSession: PropTypes.func,
    removeParticipant: PropTypes.func,
  }).isRequired,
};

export default SessionsScheduledTable;
